import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MusicForm from "../../components/discography/MusicForm";
import { ChevronLeft, Loader2 } from "lucide-react";
import { useDiscography } from "../../services/admin/DiscographyServices";

export default function EditMusicPage() {
    const navigate = useNavigate();
    const { id } = useParams();
    const { fetchMusicById, updateMusic, loading } = useDiscography();
    const [musicData, setMusicData] = useState(null);
    const [fetching, setFetching] = useState(true);



    useEffect(() => {
        const loadMusic = async () => {
            const data = await fetchMusicById(id);
            if (data) {
                setMusicData(data);
            }
            setFetching(false);
        };
        loadMusic();
    }, [id, fetchMusicById]);

    const handleUpdate = async (formData) => {
        const res = await updateMusic(id, formData);
        if (res.status === "success") {
            navigate("/admin/discography");
        }
    };

    return (
        <div className="p-6 lg:p-10 max-w-5xl mx-auto">
            {/* Navigation Header */}
            <button
                onClick={() => navigate("/admin/discography")}
                className="flex items-center gap-2 text-black dark:text-white/40 hover:text-black/70 dark:hover:text-white transition-colors text-xs font-bold tracking-widest uppercase mb-6"
            >
                <ChevronLeft size={16} /> BACK TO DISCOGRAPHY
            </button>

            <div className="max-w-6xl mx-auto">
                <div className="mb-10">
                    <h1 className="text-3xl font-bold text-black dark:text-white mb-2 font-inter tracking-tight">EDIT RELEASE</h1>
                    <p className="text-xs font-bold text-black dark:text-white/50 uppercase tracking-widest">Update details for this music entry</p>
                </div>

                {fetching ? (
                    <div className="flex flex-col items-center justify-center py-20 gap-4">
                        <Loader2 className="animate-spin text-jazz-brown" size={48} />
                        <p className="text-sm font-bold text-black dark:text-white/50 uppercase tracking-widest">Fetching release details...</p>
                    </div>
                ) : musicData ? (
                    <MusicForm
                        initialData={musicData}
                        onSubmit={handleUpdate}
                        isEditing={true}
                        isLoading={loading}
                    />
                ) : (
                    <div className="text-center py-20">
                        <p className="text-red-500 font-bold">Failed to load music details.</p>
                        <button onClick={() => navigate("/admin/discography")} className="mt-4 text-xs font-bold underline uppercase tracking-widest">Back to list</button>
                    </div>
                )}
            </div>
        </div>
    );
}
